import Vue from 'vue';
import Router from 'vue-router';
import StarterHeader from '../layout/starter/StarterHeader';
import AppHeader from '../layout/AppHeader';
import AppFooter from '../layout/AppFooter';
import PageHeader from '../layout/PageHeader';
import Home from '../views/Home';
import Menu from '../views/Menu';
import AboutUs from '../views/AboutUs';
import Gallery from '../views/Gallery';
import ErrorPage from '../views/404';
import Login from '../views/Login';
import Signup from '../views/Signup';
import Contact from '../views/Contact';
import Products from '../views/Products';
import ProductDetails from '../views/ProductDetails';
import Checkout from '../views/Checkout';


import Cart from '../views/Cart';
import News from '../views/News';
import NewsDetails from '../views/NewsDetails';

Vue.use(Router)

export default new Router({
  mode: 'history',
  /*base: process.env.BASE_URL,*/
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'Home',
      components: {
        header: StarterHeader,
        default: Home,
        footer: AppFooter
      }
    },
    /*=========================================================================================
    Food Menu Page Route
    {
      path: '/food-menu',
      name: 'FoodMenu',
      components: {
        header: AppHeader,
        default: Menu,
        footer: AppFooter
      }
    },
    {
      path: '/pages/about-us',
      name: 'AboutUs',
      components: {
        header: AppHeader,
        default: AboutUs,
        footer: AppFooter
      },
    },
    {
      path: '/pages/gallery',
      name: 'Gallery',
      components: {
        header: AppHeader,
        default: Gallery,
        footer: AppFooter
      },
    },
    {
      path: '/pages/404',
      name: '404Page',
      components: {
        header: PageHeader,
        default: ErrorPage
      },
    },
    {
      path: '/pages/login',
      name: 'login',
      components: {
        header: PageHeader,
        default: Login
      },
    },
    {
      path: '/pages/signup',
      name: 'Signup',
      components: {
        header: PageHeader,
        default: Signup
      }
    },
    {
      path: '/pages/contact',
      name: 'Contact',
      components: {
        header: AppHeader,
        default: Contact,
        footer: AppFooter
      }
    },
    {
      path: '/shop/products',
      name: 'Products',
      components: {
        header: AppHeader,
        default: Products,
        footer: AppFooter
      }
    },
    {
      path: '/shop/product-details/:id',
      name: 'ProductDetails',
      components: {
        header: AppHeader,
        default: ProductDetails,
        footer: AppFooter
      }
    },
    {
      path: '/shop/checkout',
      name: 'Checkout',
      components: {
        header: AppHeader,
        default: Checkout,
        footer: AppFooter
      }
    },
    {
      path: '/shop/cart',
      name: 'Cart',
      components: {
        header: AppHeader,
        default: Cart,
        footer: AppFooter
      }
    },
    {
      path: '/news',
      name: 'News',
      components: {
        header: AppHeader,
        default: News,
        footer: AppFooter
      }
    },
    {
      path: '/news-details',
      name: 'NewsDetails',
      components: {
        header: AppHeader,
        default: NewsDetails,
        footer: AppFooter
      }
    }
    ===========================================================================================*/
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js